export const ROUTES_PATH = Object.freeze({
  ADMIN: {
    JOBS: '/jobs',
    PROPERTIES: '/properties',
    USERS: '/users',
  },
  HELP_AND_TRAINING: {
    DOCUMENTATION: '/documentation',
  },
  PRODUCTS: {
    PATH: '/products',
  },
  SELF_SERVICE: {
    PATH: '/self_service',
    ORDER_REMOTES: '/self_service/order_remotes',
    ORDER_REMOTES_SUCCESS: '/self_service/order_remotes/success',
  },
  IN_ROOM_DINNING: {
    ORDERS: '/orders',
  },
  NO_AUTH: 'noauth',
});
